import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import '../public/lib/css/cardSpecV3.css'
import { createPinia } from 'pinia'

import jQuery from 'jquery'
import smoothScroll from 'vue-smoothscroll'
import LoadScript from 'vue-plugin-load-script'

// v3
import commonV3 from '@/v3/common'
import SelectV3 from '@/components/v3/Select'
import SelectSizeMV3 from '@/components/v3/SelectSizeM'
import ManufactureSelectV3 from '@/components/v3/ManufacturerSelect'
import CarTypeSelectV3 from '@/components/v3/CarTypeSelect'
import ModalAlertV3 from '@/components/v3/Modal/Alert'
import MPCancelModalAlertV3 from '@/components/v3/Modal/MaintenancePackCancelAlert'
import CompleteModalAlertV3 from '@/components/v3/Modal/CompleteAlert'
import AdmissionFeeReminderAlertV3 from '@/components/v3/Modal/AdmissionFeeReminderAlert'
import MPSpecifiedCommercialTransactionsModalAlertV3 from '@/components/v3/Modal/MaintenancePackSpecifiedCommercialTransactionsAlert'

global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

const app = createApp(App)
app.use(router)
app.use(store)
app.use(smoothScroll)
app.use(LoadScript)

const pinia = createPinia()
app.use(pinia)

// v3
app.component('vue-select-v3', SelectV3)
app.component('vue-select-m-v3', SelectSizeMV3)
app.component('vue-manufacture-select-v3', ManufactureSelectV3)
app.component('vue-car-type-select-v3', CarTypeSelectV3)
app.component('modal-alert-v3', ModalAlertV3)
app.component('mp-cancel-modal-alert-v3', MPCancelModalAlertV3)
app.component('complete-modal-alert-v3', CompleteModalAlertV3)
app.component('admission-fee-reminder-alert-v3', AdmissionFeeReminderAlertV3)
app.component('mp-specified-commercial-transactions-alert-v3', MPSpecifiedCommercialTransactionsModalAlertV3)

/**
 * URLからWebViewバージョンを判断するための正規表現を生成する
 *
 * @param {string} version - バージョン識別子
 * @returns {RegExp} - 指定されたバージョンパスにマッチする正規表現
 */
const injectionMatch = (version) => {
  return new RegExp(`/${version}/`)
}

if (window.location.href.match(injectionMatch('v3'))) {
  app.mixin(commonV3)
}

app.config.globalProperties.$filters = {
  addComma (val) {
    return val.toLocaleString()
  },
  checkFirstYear (val) {
    return (val === 1) ? '元' : val
  },
  roundDown (val) {
    return Math.floor(val)
  },
  oilExchanged (val) {
    return (val === 0) ? '必要' : '不要'
  }
}

app.mount('#app')
